module.exports = __webpack_public_path__ + "static/media/richest-man-in-babylon.338793b4.jpeg";